var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"height":"100vh"}},[_c('v-img',{staticClass:"window-display-image",staticStyle:{"margin-top":"50px"},attrs:{"src":_vm.imgUrl,"contain":"","max-height":"1280"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }